import { Component, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import MediaQueries from '../util/media-queries-helper';

declare var impress: any;
declare var $: any;

@Component({
  selector: 'facestar-page',
  templateUrl: './facestar-page.component.html',
  styleUrls: ['./facestar-page.component.scss']
})
export class FacestarPageComponent implements AfterViewInit, OnDestroy {

  xl: boolean = true;

  public elm = document.getElementById("navbar");
  public elm2 = document.getElementById("myNavbar");
  public menu = document.getElementById("menu");
  public tab = document.getElementsByClassName("tab");
  public tabMenu = document.getElementById("tabMenu");

  constructor(private _NgZone: NgZone) {

    var html = "<li _ngcontent-c1 class='details'><a _ngcontent-c1 routerLink='/home' ng-reflect-router-link='/home' href='/home' class='tab' id='tabName'>HOME</a></li>";
    this.tabMenu.insertAdjacentHTML('afterbegin', html);

    this.menu.setAttribute("src", "/assets/navbar/imgpsh_fullsize.png");
    for (let a = 0; a < this.tab.length; a++) {
      this.tab[a].setAttribute("style", "color: #2F4F4F!important; text-shadow: none!important");
    }

    if ($(window).width() < 1081) {
      this.xl = false;

      this.elm.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
      this.elm2.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
    } else {
      this.xl = true;

      this.elm.style.backgroundColor = 'transparent';
      this.elm2.style.backgroundColor = 'transparent';
    }



    MediaQueries.matcheQuery("xl").addListener((/*mql: MediaQueryList*/) => {
      _NgZone.run(() => {
        if (MediaQueries.querySelect() == 'xl') {
          this.xl = true;

          this.elm.style.backgroundColor = 'transparent';
          this.elm2.style.backgroundColor = 'transparent';
        } else {
          this.xl = false;

          this.elm.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
          this.elm2.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
        }
      });
    });
  }

  load() {
    impress().init();
  }

  prev() {
    var imp = impress();
    imp.prev();
  }

  next() {
    var imp = impress();
    imp.next();
  }

  ngAfterViewInit() {
    this.load();
  }

  ngOnDestroy(): void {
    this.elm.style.backgroundColor = 'transparent';
    this.elm2.style.backgroundColor = 'transparent';
    this.menu.setAttribute("src", "/assets/navbar/menu.png");
    for (let a = 0; a < this.tab.length; a++) {
      this.tab[a].removeAttribute("style");
    }

    var tabName = document.getElementById("tabName");
    if (tabName) {
      document.getElementById("tabName").remove();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/facestar-page/facestar-page.component.ts